export class Uploads {
    constructor({
        uploadID = 0,
        orderID = 0,
        files = null,
    } = {}) {
        this.uploadID = uploadID;
        this.orderID = orderID;
        this.files = files;
    }
}

export function createUploads(data) {
    return Object.freeze(new Uploads(data));
}
